module.exports = __webpack_public_path__ + "static/img/Jepang.9d93181.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/landmark/Jepang.png
// module id = 0BsF
// module chunks = 1